export const STAGES = {
  INITIAL: "initial",
  SUCCESS: "success",
  ERROR: "error",
};

export const initialBoxValues = [
  "$25k-$50k",
  "$50k-$100k",
  "$100k-$250k",
  "$250k-$500k",
  "$500k-$1M",
  "Over $1M",
];

export const MEMBER_ORGANIZATIONS = ["AIM" , "WIN" , "IMPALA" , "Not A Memeber"];

export const HEARD_FROM = ['Instagram', 'Facebook', 'LinkedIn', 'Google', 'beatBread Emailed Me', 'Industry News Outlet', 'Referred by Someone'];

export const SWITCH_DISTRIBUTORS = ["Unsure", "Yes", "No"];
